<div class='wrapper'>
  <div class='header'>
    <p style="vertical-align: center; text-align: center;">
      <img src="../../../assets/ldw-logo.png" title="LiveDOK-Web" /> <br />
      <label >{{longVersion}}</label>
    </p>
  </div>
  <div class='content'>
    <p style="vertical-align: center; text-align: center;">
      <label style="text-align:center; font-size: large"> {{('ERROR.OPENIDLOGIN'| translate)}}</label>
      <br /><br />
      <label style="text-align:center; font-size: medium "> {{('ERROR.OPENIDLOGINTEXT'| translate)}}</label>
      <br /><br />
      <button mat-raised-button (click)="login($event)" matTooltip="{{ showToolTip()? ('DIALOGS.RELOGIN' | translate) :''  }}" >
        <mat-icon class="button-icon-person">person</mat-icon>{{'DIALOGS.RELOGIN'|translate}}
      </button>
    </p>
  </div>
</div>
